/**
 * Продуктовая аналитика PostHog (EU): экраны, клики для тепловых карт, записи сессий.
 *
 * Работает только на боевом домене и вне демо-режима: локальная разработка и
 * демо в браузере ничего не отправляют. Админка сюда не попадает — main.tsx
 * вызывает startAnalytics только для Mini App.
 */
import posthog from 'posthog-js';

/** Публичный ключ проекта: он и так виден в коде страницы, секретом не является. */
const KEY = 'phc_pWfxQTwQSfVPpE5DyyR8X4oLhbYiuKQgJ8ZVpUnDtAUE';
const HOST = 'https://eu.i.posthog.com';
const PRODUCTION_HOST = 'app.getmill.app';

let enabled = false;
let identified: string | null = null;

/** Адрес без данных запуска Telegram: в hash лежит initData, по которой можно войти. */
export function cleanUrl(value: string): string {
  try {
    const url = new URL(value);
    url.hash = '';
    for (const key of [...url.searchParams.keys()]) {
      if (key.startsWith('tgWebApp')) url.searchParams.delete(key);
    }
    return url.toString();
  } catch {
    return value;
  }
}

export function startAnalytics(demo: boolean): void {
  if (enabled || demo || window.location.hostname !== PRODUCTION_HOST) return;
  // Telegram хранит параметры запуска в sessionStorage и восстанавливает их
  // при перезагрузке, поэтому из адресной строки их можно убрать до старта записи.
  window.history.replaceState(window.history.state, '', cleanUrl(window.location.href));
  posthog.init(KEY, {
    api_host: HOST,
    person_profiles: 'identified_only',
    persistence: 'localStorage',
    // Экраны меняются без смены адреса: просмотры отправляет trackScreen.
    capture_pageview: false,
    capture_pageleave: true,
    autocapture: true,
    enable_heatmaps: true,
    session_recording: { maskAllInputs: true },
    before_send: (event) => {
      if (!event) return event;
      for (const [key, value] of Object.entries(event.properties ?? {})) {
        if (typeof value === 'string' && /url|referrer/i.test(key)) event.properties[key] = cleanUrl(value);
      }
      return event;
    },
  });
  enabled = true;
}

/** Экран в адресе (?screen=) разделяет тепловые карты и прокрутку по экранам. */
export function trackScreen(screen: string): void {
  if (!enabled) return;
  const url = new URL(window.location.href);
  if (url.searchParams.get('screen') !== screen) {
    url.searchParams.set('screen', screen);
    window.history.replaceState(window.history.state, '', url.toString());
  }
  posthog.capture('$pageview', { screen });
}

/**
 * Внутренний id пользователя и ник Telegram: по нику записи сессий находят в PostHog
 * (name показывается как имя персоны). Telegram ID не передаём.
 */
export function identifyUser(userId: string, username: string | null): void {
  const key = `${userId}:${username ?? ''}`;
  if (!enabled || identified === key) return;
  identified = key;
  posthog.identify(userId, username ? { name: `@${username}`, username } : {});
}
